<template>
	<div v-if="version">
		<PaidWeb
			v-if="coupon"
			:version="version"
			:coupon="coupon"
			:planData="planData"
			@closeDetail="closeDetail"
			class="not-mobile"
			:price="price"
		/>
		<PaidMobile
			:version="version"
			:planData="planData"
			@closeDetail="closeDetail"
			:coupon="coupon"
			class="is-mobile"
			:price="price"
		/>
	</div>
</template>
<script>
import PaidMobile from './PaidMobile.vue'
import PaidWeb from './PaidWeb'
import buyStore from '../../../../utils/buyStore'
export default {
	data() {
		return {}
	},
	computed: {
		version() {
			return buyStore.currentVersion
		},
		planData() {
			return buyStore.planData
		},
		coupon() {
			return buyStore.coupon
		},
		price() {
			return buyStore.getPrice(buyStore.currentVersion)
		},
	},
	components: {
		PaidMobile,
		PaidWeb,
	},
	methods: {
		closeDetail() {
			buyStore.$emit('closeDetail')
		},
	},
}
</script>
<style lang="scss" scoped></style>
